import StyledTitle from "./Title";
import { Muted } from "./styles";

export { Muted };
export default StyledTitle;
